var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenubackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.098,
    height: 71.758,
    viewBox: "0 0 62.098 71.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M31.049,0,62.1,17.936V53.812L55.07,57.869l-.052-36.238L31.044,7.391,20.331,13.811,20.31,6.2,31.049-.01Zm2.007,36.039,12.306,7v12.82l-14.314,8.5L7.076,50.112V13.843L0,17.936V53.812L31.049,71.748l20.43-11.8V24.126L33.057,13.612v7.851l12.306,7v6.745L33.057,28.183v7.851ZM10.98,5.436,17.039,1.3l.047,19.822,11.971-7.107L29,58.378,10.839,47.7,10.98,5.441Zm5.75,22.653,6.185-3.265-.073,22.045-6.111-3.25V28.094Z",
    transform: "translate(0 0.01)",
    fill: "#2e4955",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubackground);
export default __webpack_public_path__ + "static/media/menubackground.8ce6fc4a191a8c0ffe7cdac1b2e845fc.svg";
export { ForwardRef as ReactComponent };